import React, { Fragment } from "react";
import { Typography, Box, Card, Paper } from "@mui/material";
import "./IconButton.css";

const IconButton = ({
  label,
  icon,
  iconHover,
  iconSize,
  iconClicked,
  style,
  onClick,
  hideShadow,
  disabled,
}) => {
  return (
    <Fragment>
      {disabled && (
        <Box className="icon-container" style={style}>
          <Paper className={"icon-button" + (hideShadow ? " no-shadow" : "")}>
            <img
              className="disabled"
              src={icon}
              style={{
                height: iconSize,
                width: iconSize,
              }}
            />
          </Paper>
          <Typography variant="body2">{label}</Typography>
        </Box>
      )}
      {!disabled && (
        <Box className="icon-container" style={style} onClick={onClick}>
          <Paper className={"icon-button" + (hideShadow ? " no-shadow" : "")}>
            <img
              className="inactive"
              src={icon}
              style={{
                height: iconSize,
                width: iconSize,
              }}
            />
            <img
              className="hover"
              src={iconHover}
              style={{
                height: iconSize,
                width: iconSize,
              }}
            />
            <img
              className="active"
              src={iconClicked}
              style={{
                height: iconSize,
                width: iconSize,
              }}
            />
          </Paper>
          <Typography className="icon-text" variant="body2">
            {label}
          </Typography>
        </Box>
      )}
    </Fragment>
  );
};

export default IconButton;
//prevent the hover bold shifting position by setting a wide enough width
